import { render } from "./AdvertSideBar.vue?vue&type=template&id=53b08424"
import script from "./AdvertSideBar.vue?vue&type=script&lang=js"
export * from "./AdvertSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__